// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__21YoA","inputWrap":"styles_inputWrap__1d_MJ","input":"styles_input__ALofR"};